import { createSlice } from '@reduxjs/toolkit';
import { resetAll } from '../resetState.action';
import { RootState } from '../store';

interface InitialState {
    user?: User;
    client?: Client;
    token?: string;
}

const initialState: InitialState = {
    user: undefined,
    client: undefined,
    token: undefined,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state, action) => {
            // return action.payload;
            state.user = action.payload.user;
            state.client = action.payload.client;
            state.token = action.payload.access_token;
        },
        refreshProfile: (state, action) => {
            state.client = action.payload.client;
            state.user = action.payload.user;
        },
        refreshUser: (state, action) => {
            state.user = { ...state.user, ...action.payload };
        },
        refreshClient: (state, action) => {
            state.client = action.payload;
            state.user = action.payload.user;
        },
        logout: (state) => {
            state.user = undefined;
            state.client = undefined;
            state.token = undefined;
        },
    },
    extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
});

// selectors
export const getUser = (state: RootState) => state.auth.user;
export const getClient = (state: RootState) => state.auth.client;
export const getAuthToken = (state: RootState) => state.auth.token;
export const getAuth = (state: RootState) => state.auth;

// actions & reducer
export const { actions, reducer } = authSlice;
